(function ($) {
    $.fn.FormTrigger = function (options) {
        var settings = $.extend({
            'targets' : [
                // 'target1',
                // 'target2',
            ],
            'url' : ''
        }, options);
        $(document).on('change','#'+$(this).attr('id'),function (){
            var targets = settings['targets'];
            var $form = $(this).closest('form');
            var data = $form.serializeArray();

            var triggered = data.find(obj =>
                obj.name === $(this).attr('name')
            )

            if (triggered === undefined){
                data.push({
                    name: $(this).attr('name'),
                    value: $(this).val()
                });
            }
            var url = settings['url'] ? settings['url'] : $form.attr('action');
            $.ajax({
                url : url,
                type: $form.attr('method'),
                data : data,
                success: function(html) {
                    for (var target in targets){
                        $('#'+targets[target]).replaceWith(
                            $(html).find('#'+targets[target])
                        );
                        if ($(html).find('#'+targets[target]).find('input').hasClass('datalist')){
                            $(html).find('#'+targets[target]).find('input').Datalist();
                        }
                        handleDatePicker('#'+targets[target]);
                    }
                }
            });
        });
    }
}(jQuery));


// WEBPACK FOOTER //
// ./assets/js/formTrigger.js